import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import Subsection from './indexStyles.js';
import MainComponent from './MainComponent';

const App = ({
  history
}) => /*#__PURE__*/React.createElement(Subsection, null, /*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(MainComponent, {
  history: history
})));

export default App;